import { Injectable } from '@angular/core';
import { HTTP,HTTPResponse } from '@ionic-native/http';
import { ConfigurationManager } from './ConfigurationManager';

@Injectable()
export class FavouritePartnerService {



    constructor(private http: HTTP, private config: ConfigurationManager) { }




    getPartnersList() {


        const headers = {
            'Content-Type': 'application/json',
            'x-api-key': this.config.environmentConfig.apikey,
            'Accept': 'application/json'
        };



        const params = {
            'Criteria': 'all',
            'SessionID': this.config.getSessionId,
            'ProxyUI': this.config.getProxyUI,
            'ClubID': this.config.getClubCode,
            'FromNewDNR': 'true',
        };
        console.log('params' + params);
        const url = this.config.environmentConfig.baseurl + 'prlst/v1';
        return this.http.get(url, params, headers);

    }
}
